import request from '@/utils/request'
// 实例申请
export function getConnectInstance(data) {
  return request({
    url: '/v1/web_app/connect_device',
    method: 'post',
    data
  })
}
// 实例释放
export function disconnectInstance(data) {
  return request({
    url: '/v1/web_app/disconnect_device',
    method: 'post',
    data
  })
}
// 获取 uuid
export function getUuid(data) {
  return request({
    url: '/v1/web_app/get_uuid',
    method: 'post',
    data
  })
}